import { Callbacks } from "jquery";
import { CompanyActorClient } from "../../../../../../../Wrap/Api/Customer/CompanyActor";
import { TrustAuthorisationRequestsClient } from "../../../../../../../Wrap/Api/Customer/TrustAuthorisationRequests";
import { TrustMemberClient } from "../../../../../../../Wrap/Api/Customer/TrustMember";
import { TrustMemberHistoryClient } from "../../../../../../../Wrap/Api/Customer/TrustMemberHistory";
import { TrustServicingModelClient } from "../../../../../../../Wrap/Api/Customer/TrustServicingModel";
import { TrustShareClient } from "../../../../../../../Wrap/Api/Customer/TrustShare";
import { TrustAuthorisationRequestType } from "../../../../../../../Wrap/Constants/Enums/Customer/TrustAuthorisationRequestType";
import { TrustRemovalReason } from "../../../../../../../Wrap/Constants/Enums/Customer/TrustRemovalReason";
import { AuthorisationStatus } from "../../../../../../../Wrap/Models/Models/Common/AuthorisationStatus";
import { Company } from "../../../../../../../Wrap/Models/Models/Customer/Company";
import { Organisation } from "../../../../../../../Wrap/Models/Models/Customer/Organisation";
import { OrganisationMember } from "../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { TrustMemberBulkRequest } from "../../../../../../../Wrap/Models/Models/Customer/TrustMemberBulkRequest";

export class AddTrustMemberAction {
    public static getTrustServicingModel(customerId: number, callback) {
        const client = new TrustServicingModelClient();
        const promise = client.get(customerId);
        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static addTrustMembers(organisation: Organisation, callback) {
        const client = new TrustMemberClient();
        const promise = client.post(organisation);
        promise.onSuccess((d) => {
            callback(d);
        });
    }

    public static removeTrustMember(organisation: Organisation, reason: TrustRemovalReason, dateOfDeath, callback) {
        const client = new TrustMemberClient();
        const promise = client.delete(organisation, reason, dateOfDeath);
        promise.onSuccess((d) => {
            callback();
        });
    }

    public static createCompany(company: Company, ownerAdviserId: number, callback) {
        const client = new CompanyActorClient();
        const promise = client.post(ownerAdviserId, company);
        promise.onSuccess((d) => {
            callback(d.CustomerId);
        });
    }

    public static postTrustAuthorisation(
        customerId: number,
        organisationId: number,
        authorisationType: TrustAuthorisationRequestType,
        reason: TrustRemovalReason,
        callback
    ) {
        const client = new TrustAuthorisationRequestsClient();
        const promise = client.post(customerId, organisationId, authorisationType, reason);
        promise.onSuccess((d) => {
            callback();
        });
    }

    public static getShareOfTrust(customerId: number, callback) {
        const client = new TrustShareClient();
        const promise = client.get(customerId);
        promise.onSuccess((d) => {
            callback(d);
        });
    }

    public static getTrustAuthorisationRequests(
        organisationId: number,
        reason: TrustRemovalReason,
        status: AuthorisationStatus,
        trustMemberIds: Array<number>,
        callback?
    ) {
        const client = new TrustAuthorisationRequestsClient();
        const promise = client.get(organisationId, reason, status, trustMemberIds);
        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static getTrustMemberHistory(customerId: number, organisationId: number, accountId: number, callback?) {
        const client = new TrustMemberHistoryClient();
        const promise = client.get(customerId, accountId, organisationId);
        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static bulkGetTrustMemberHistory(
        customerId: Array<number>,
        organisationId: number,
        accountId: number,
        callback?
    ) {
        const client = new TrustMemberHistoryClient();
        const request: TrustMemberBulkRequest = {
            CustomerIds: customerId,
            AccountId: accountId,
            OrganisationId: organisationId
        };
        const promise = client.post(request);
        promise.onSuccess((result) => {
            callback(result);
        });
    }
}
